<template>
  <section>
    <v-layout wrap class="hidden-sm-and-down">
      <v-flex md12 class="top-breadcrumbs">
        <v-container grid-list-md>
          <v-layout>
          <v-breadcrumbs :items="breadcrumbs" divider=" / "></v-breadcrumbs>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
    <v-container grid-list-md pt-md-12 mb-12>
      <v-layout wrap>
        <v-flex xs12 sm12 md12 lg12>
          <v-layout wrap>
            <v-flex xs12 sm12 md12 lg12>
              <div v-if="detail" v-html="detail.content" class="detail-content">
                {{detail.content}}
              </div>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
    <back-to-top bottom="60px" right="10px" visibleoffset="1080">
      <v-btn
        color="black"
        class="btn-to-top"
        depressed
      >
        <v-icon>mdi-chevron-up</v-icon>
      </v-btn>
    </back-to-top>
  </section>
</template>
<script>
import BackToTop from 'vue-backtotop'
export default {
  components: { BackToTop },
  data: () => ({
    breadcrumbs: [],
    category: null,
    detail: null
  }),
  created () {
    this.breadcrumbs = [
      { text: '产品中心', disabled: true }
    ]
    this.getProduct(this.$route.params.id)
  },
  computed: {
    info () {
      return this.$store.getters.companyInfo
    }
  },
  watch: {
    category: {
      handler: function (val, oldVal) {
        this.parseBreadcrumbs(val)
      },
      deep: true
    },
    detail: {
      handler: function (val, oldVal) {
        this.getCategory(val.cid)
        this.$nextTick(function () {
          /*
          if (this.innerWidth < 550) {
            let imgs = document.querySelectorAll('.product-content img')
            imgs.forEach((img, i) => {
              img.classList.add('full-img')
            })
          }
          */
        })
      },
      deep: true
    }
  },
  methods: {
    getCategory (id) {
      this.https.get('product_category', { id: id }).then(response => {
        if (response.code === 0) {
          this.category = response.data
        }
      })
    },
    getProduct (id) {
      this.https.get('product', { id: id }).then(response => {
        if (response.code === 0) {
          this.detail = response.data
          document.title = this.detail.title + '_' + '德国玛娅家居 | Maier Home'
        }
      })
    },
    parseBreadcrumbs (category) {
      this.breadcrumbs.push({ text: category.pcat.name, disabled: true })
      this.breadcrumbs.push({ text: category.cat.name, disabled: false, href: '/products/' + category.cat.id })
      this.breadcrumbs.push({ text: this.detail.title, disabled: true })
    }
  }
}
</script>
<style lang="css">
  @import '../css/product.css';
</style>
